module.exports = __webpack_public_path__ + "img/15_windAndRain_ybh.3abec070.png";